import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=2f11e9d9&scoped=true&"
import script from "./Empty.vue?vue&type=script&lang=ts&"
export * from "./Empty.vue?vue&type=script&lang=ts&"
import style0 from "./Empty.vue?vue&type=style&index=0&id=2f11e9d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f11e9d9",
  null
  
)

export default component.exports